<jhi-bary-card [titleKey]="'baryApp.pricing-search.title'">
  <div body>
    <div class="alert alert-info">
      <div class="row align-items-center">
        <div class="col-auto">
          <mdb-icon fas icon="info-circle" size="2x"></mdb-icon>
        </div>
        <div class="col">
          <span jhiTranslate="PRICING_LIST.SEARCH_BAR.HELP_BANNER">Find which price will be applied</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <p class="bold" jhiTranslate="PRICING_LIST.SEARCH_BAR.INPUT_FIELD.PICKUP">Pickup</p>
        <div class="row">
          <div class="col">
            <jhi-bary-address-form [id]="'pickup-address'" [addressForm]="formGroup.controls.pickupAddress!" [options]="{ withAdditional: false, withAddressNotFoundForm: false }">
            </jhi-bary-address-form>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <p class="bold" jhiTranslate="PRICING_LIST.SEARCH_BAR.INPUT_FIELD.DELIVERY">Delivery</p>
        <div class="row">
          <div class="col">
            <jhi-bary-address-form
              [id]="'delivery-address'"
              [addressForm]="formGroup.controls.deliveryAddress!"
              [options]="{ withAdditional: false, withAddressNotFoundForm: false }"
            >
            </jhi-bary-address-form>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <p class="bold">Quantité</p>
        <div class="row">
          <div class="col-6">
            <jhi-bary-input-number [control]="formGroup.controls.quantity" [label]="'baryApp.pricing-search.quantity' | translate"></jhi-bary-input-number>
          </div>
          <div class="col-6 mt-2">
            <jhi-bary-button icon="search" [disabled]="!canSearch()" [label]="'baryApp.pricing-search.search' | translate" (clickEvent)="searchPricing()"></jhi-bary-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2" *ngIf="!hasResults() && submit">
      <div class="col-12">
        <p jhiTranslate="PRICING_LIST.SEARCH_BAR.NO_RESULT">No result</p>
      </div>
    </div>
    <div class="row mt-2" *ngIf="hasResults()">
      <div class="col-12">
        <table class="table bg-white">
          <tr class="bg-main">
            <th jhiTranslate="PRICING_LIST.COLUMN.PICKUP.COUNTRY_CODE">Pickup country code</th>
            <th jhiTranslate="PRICING_LIST.COLUMN.PICKUP.ZIP_CODE_RULE">Pickup zip code rule</th>
            <th jhiTranslate="PRICING_LIST.COLUMN.DELIVERY.COUNTRY_CODE">Delivery country code</th>
            <th jhiTranslate="PRICING_LIST.COLUMN.DELIVERY.ZIP_CODE_RULE">Delivery zip code rule</th>
            <th jhiTranslate="LABEL.PRICE">Price</th>
            <th
              *ngIf="eligiblePricing?.transporterDefaultMarginRate > 0"
              jhiTranslate="PRICING_LIST.COLUMN.ESTIMATED_PRICE_WITH_MARGIN"
              [translateValues]="{ margin: eligiblePricing.transporterDefaultMarginRate }"
            >
              Transport Price
            </th>
            <th class="bg-info" jhiTranslate="PRICING_LIST.COLUMN.SCORE">Score</th>
          </tr>
          <tr *ngFor="let pricingItem of eligiblePricing.pricingItems">
            <td>{{ pricingItem.pickupCountry }}</td>
            <td>{{ pricingItem.pickupZipCodeData }}</td>
            <td>{{ pricingItem.deliveryCountry }}</td>
            <td>{{ pricingItem.deliveryZipCodeData }}</td>
            <td>{{ pricingItem.price | currency: 'EUR' }}</td>
            <td *ngIf="eligiblePricing?.transporterDefaultMarginRate">{{ getTransportPrice(pricingItem) | currency: 'EUR' }}</td>
            <td class="bg-info">{{ calculateScore(pricingItem) }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row mt-2" *ngIf="hasSpecialPlaceResults()">
      <div class="col-6">
        <table class="table bg-white">
          <tr class="bg-main">
            <th jhiTranslate="PRICING_LIST.COLUMN.SPECIAL_PLACE">Special place</th>
            <th jhiTranslate="LABEL.PRICE">Prix</th>
          </tr>
          <tr *ngFor="let pricingItem of eligiblePricing.specialPlacePricingItems">
            <td>{{ pricingItem.pricing?.specialPlaceList?.name }}</td>
            <td>{{ pricingItem.price | currency: 'EUR' }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</jhi-bary-card>
